<template>
  <CelusAlert type="info">
    <slot />
  </CelusAlert>
</template>

<script setup lang="ts">
import CelusAlert from "@/components/util/CelusAlert.vue";

defineOptions({
  name: "CelusInfoAlert",
});
</script>
